export type JSONPatchOperation = {
  op:
    | "replace"
    | "add"
    | "remove"
    // the following are required to allow us to duck type the
    // output of fast-json-patch `compare` to this generic model
    | "move"
    | "copy"
    | "test"
    | "_get";
  path: string;
  value?: any;
};

export type JSONPatchDocument = JSONPatchOperation[];

export type ChangeMeta = { field: string; oldValue: string; newValue: string };

export type PatchWithMeta<T> = {
  document: JSONPatchDocument;
  meta: ChangeMeta[];
};

export type ModelWithMeta<T> = {
  model: T;
  meta: ChangeMeta[];
};

export type Model = { [key: string]: any };

export interface PagedResponse<T> {
  data: T[];
  count: number;
  page: number;
  pageSize: number;
  extendedProperties?: { [key: string]: string };
}

export const PagedResponseEmpty: PagedResponse<never> = {
  data: [],
  count: -1,
  page: -1,
  pageSize: -1,
};

export const isPagedResponseEmpty = (pagedResponse: PagedResponse<unknown>) =>
  pagedResponse.count === -1;

export type QueryParams = {
  [key: string]: any;
};

export type Opts = {
  token?: string;
  opts?: Partial<RequestInit>;
};

export type ValidatedResponse<T> =
  | {
      isValid: true;
      data: T;
    }
  | {
      isValid: false;
      error: ValidationError;
    };

export type ValidationError = {
  errors: { [key: string]: string[] };
  title: string;
  status: number;
};

export * from "./LegacyPagedResponse";

export type LookupTrackerRegisterArg = {
  name: unknown;
  id: unknown;
  label: string;
};

export type LookupTrackerFindArg = {
  name: unknown;
  id: unknown;
};

export type LookupTrackerStore = { [key: string]: { [key: string]: string } };

export type LookupTracker = {
  register: (arg: LookupTrackerRegisterArg) => void;
  find: (arg: LookupTrackerFindArg) => string | undefined;
  raw: () => LookupTrackerStore;
};

export type UserAuth = {
  upn: string;
  displayName: string;
  token: string;
  roles: number[];
  userType: number;
  org: {
    id: number;
    name: string;
    acronym: string;
  };
  experimentalFeatures: {
    moduleName: string;
    featureName: string;
    toggleType: number;
  }[];
};